import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Select, Col, Row, Spin} from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

const Communique: React.FC = ({}) => {
  const [items, setImageCategoryData] = useState<[]>([]);
  const [subitems, setImageSubCategoryData] = useState<[]>([]);
  const [selectedItem, setSelectedImageCategory] = useState('');
  const [selectedSubItem, setSelectedImageSubCategory] = useState('');
  const [headerText, setHeaderText] = useState('');
  const [description, setDescription] = useState('');
  const [imageURL, setimageURL] = useState('');
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [selectedPDF, setSelectedPDF] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false); // Loading state

  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        getImageCategoryData();
      }, []);
      
        // File size limit (in bytes)
        const max_file_size = 1000 * 1024; // 500 KB
        // Allowed file extensions
        const allowed_extension = ['jpg', 'jpeg', 'png', 'gif'];

        // File size limit (in bytes)
        const pdfmax_file_size = 10000 * 1024; // 10MB
        // Allowed file extensions
        const pdfallowed_extension = ['pdf'];

  const handleSubmit = async () => {
    if (!selectedItem || !headerText || !selectedImage) {
      message.error('Please fill all fields');
      return;
    }   

    if (selectedImage.size > max_file_size) {
      message.error('File size exceeds 1MB limit.');
      return;
    }
    const file_extension = selectedImage.name.split('.').pop()?.toLowerCase();
    if (!allowed_extension.includes(file_extension || '')) {
      message.error('Invalid file type. Only jpg, jpeg, png and .gif are allowed.');
      return;
    }
    if (selectedPDF){
      const pdf_extension = selectedPDF?.name.split('.').pop()?.toLowerCase();
      if (selectedPDF.size > pdfmax_file_size) {
        message.error('File size exceeds 10MB limit.');
        return;
      }
      if (!pdfallowed_extension.includes(pdf_extension || '')) {
        message.error('Invalid file type. Only .pdf file are allowed.');
        return;
      }
    }
 
    
    setLoading(true); // Start loading

    const userId = localStorage.getItem("UserId");

    const formData = new FormData();
    formData.append('file', selectedImage); // Append the image file
    formData.append('ImageCategoryId', selectedItem); // Append the text data
    formData.append('ImageSubCategoryId', selectedSubItem);
    formData.append('HeaderText', headerText);
    formData.append('Description', description);
    formData.append('CreatedBy', userId || '');
    formData.append('ImageURL', imageURL);
    if (selectedPDF) {
      formData.append('pdffile', selectedPDF); // Append the PDF file
    }

    try {
      const token = await fetchToken();
      await axios.post(`${API_URL}/api/COECommunique/SaveCOECommunique`, formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        message.success('COE Communique added successfully');
        setSelectedImageCategory('');
        setSelectedImageSubCategory('');
        setHeaderText('');
        setDescription('');
        setSelectedImage(null);
        setSelectedPDF(null);
    } catch (error) {
        message.error('Failed to save the data');
    }
    finally {
      setLoading(false); // Stop loading
    }
  };

  const handleSelectedChange = (value: string) => {
    setSelectedImageCategory(value);
    getImageSubCategoryData(value);
  }

  const handleSelectedSubCatChange = (value: string) => {
    setSelectedImageSubCategory(value);
  }

  const getImageCategoryData = async () => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/COECommunique/GetImageCategoryName`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      
      setImageCategoryData(response.data);
    } catch (error) {
      message.error('Failed to load image category data');
    }
  }

  const getImageSubCategoryData = async (imagecategoryid: string) => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/COECommunique/GetImageSubCategoryName/${imagecategoryid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      if(response.data.length === 0){
        setSelectedImageSubCategory('');
        setImageSubCategoryData([]);
      }
      else{
        setSelectedImageSubCategory('');
        setImageSubCategoryData(response.data);
      }
    } catch (error) {
      message.error('Failed to load image sub category data');
    }
  }

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setSelectedImage(file);
    }
  }

  const handlePDFUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setSelectedPDF(file);
    }
  }

  return (
    <div>
      <Spin spinning={loading} tip="Submitting...">
      <div>
          <Form layout="vertical" onFinish={handleSubmit}>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item label="Image Category Name" required>
                        <Select
                            value={selectedItem}
                            onChange={handleSelectedChange}
                        >
                            {items.map((type: any) => (
                            <option key={type.value} value={type.value}>
                                {type.text}
                            </option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Image Sub Category Name">
                        <Select
                            value={selectedSubItem}
                            onChange={handleSelectedSubCatChange}
                        >
                            {subitems.map((type: any) => (
                            <option key={type.value} value={type.value}>
                                {type.text}
                            </option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item label="Header Text" required>
                        <Input
                            value={headerText}
                            onChange={(e) => setHeaderText(e.target.value)}
                            placeholder="Enter Header Text" maxLength={150}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Upload Image" required>
                        <Input type='file' accept='image/*' onChange={handleFileUpload}></Input>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item label="Image Link">
                        <Input
                            value={imageURL}
                            onChange={(e) => setimageURL(e.target.value)}
                            placeholder="Enter Image Link" maxLength={350}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Upload PDF">
                        <Input type='file' accept='application/pdf' onChange={handlePDFUpload}></Input>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item label="Description">
                        <Input
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description" maxLength={1000}
                        />
                    </Form.Item>
                </Col>
            </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
      </Spin>
    </div>
    
  );
};

export default Communique;